// extracted by mini-css-extract-plugin
module.exports =  {"tabs":"sritCdpsAfioxd7qOyMq","body":"hqeNfT6FE_SOtvUpAgie"};